import * as React from "react"

import isLetterOrNumberOrSpecial from "@podcastsoundboard/ps-lib/helpers/validation/isLetterOrNumberOrSpecial"

import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"

export default function ShortcutPicker({
  shortcut,
  setShortcut,
}: {
  shortcut: string
  setShortcut: (value: string) => void
}) {
  const [listening, setListening] = React.useState(false)

  const handleKeypress = React.useCallback(
    (e: KeyboardEvent) => {
      if (listening) {
        if (!isLetterOrNumberOrSpecial(e.key)) {
          return
        }

        setShortcut(e.key)
        setListening(false)
      }
    },
    [listening, setShortcut],
  )

  React.useEffect(() => {
    document.addEventListener("keydown", handleKeypress)

    return () => {
      return document.removeEventListener("keydown", handleKeypress)
    }
  }, [handleKeypress])

  return (
    <Box>
      <Box sx={{ pb: 2 }}>
        <Typography variant="body1">Bind a keyboard shortcut.</Typography>
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        flexWrap="wrap"
      >
        {!listening && (
          <Button
            sx={{ mr: 2, mb: 1 }}
            variant="contained"
            onClick={() => setListening(true)}
          >
            Bind Keyboard Shortcut
          </Button>
        )}
        {listening && (
          <Button
            sx={{ mr: 2, mb: 1 }}
            variant="outlined"
            onClick={() => setListening(false)}
          >
            Listening...
          </Button>
        )}

        {shortcut && (
          <Button
            sx={{ mr: 2, mb: 1 }}
            variant="outlined"
            onClick={() => {
              setListening(false)
              setShortcut("")
            }}
          >
            Clear Shortcut
          </Button>
        )}

        {shortcut && (
          <Typography sx={{ mb: 1 }} variant="body1">
            Shortcut: {shortcut}
          </Typography>
        )}
      </Box>
    </Box>
  )
}
